module.exports = __webpack_public_path__ + "static/media/bnr8.98dcc8e9.jpg";